import { CampfireRichEditor } from '@campfire/campfire-rich-editor';
import { Box, Grid, Typography } from '@material-ui/core';
import { convertFromRaw, EditorState } from 'draft-js';
import React, { useMemo } from 'react';
import { useCampfireTheme } from '../../../theme/useCampfireTheme';
import { getFirstName } from './get-first-name';

interface ApplicationScreenScreeningFailedProps {
  orgName: string;
  content: string;
  stateController: {
    givenName: string | undefined;
  };
}

export const ApplicationScreenScreeningFailed = (props: ApplicationScreenScreeningFailedProps) => {
  const { orgName, content, stateController } = props;
  const { givenName: name } = stateController;
  const { isMobile } = useCampfireTheme();
  const maybeFirstName = name ? getFirstName(name) : undefined;

  const editorState = useMemo(() => {
    try {
      return EditorState.createWithContent(convertFromRaw(JSON.parse(content)));
    } catch {
      return null;
    }
  }, [content]);

  return (
    <Box paddingTop={isMobile ? 4 : 8} paddingBottom={isMobile ? 0 : 8}>
      <Grid justify='center' container style={{ flexGrow: 1 }}>
        <Grid item xs={12} sm={10}>
          <Typography variant='h4' align='center'>
            {maybeFirstName ? `Thank you, ${maybeFirstName}` : 'Thank You'}
          </Typography>
          <Typography variant='h6' align='center'>
            {orgName
              ? `Your application to join ${orgName} was not successful.`
              : 'Your application was not successful.'}
          </Typography>

          {editorState ? (
            <Box marginTop={3}>
              <CampfireRichEditor editorState={editorState} readOnly />
            </Box>
          ) : null}
        </Grid>
      </Grid>
    </Box>
  );
};
